import { render } from "./rentalContract.vue?vue&type=template&id=4819ab5a&ts=true"
import script from "./rentalContract.vue?vue&type=script&lang=ts"
export * from "./rentalContract.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__